export const ISSUE_DEEP_DIVE_OPENED_FROM_ISSUES = "ISSUE_DEEP_DIVE_OPENED_FROM_ISSUES";

// `fromIssues` is the Issues list a deep dive was last opened from, `{location, measure}`: hash history drops
// a location's state, so it is kept here for Back and for the tab the deep dive opens on.
const initialState = { fromIssues: null };

export default (state = initialState, action) => {
    switch (action.type) {
        case ISSUE_DEEP_DIVE_OPENED_FROM_ISSUES:
            return { ...state, fromIssues: action.payload };
        default:
            return state;
    }
};
